import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { measurementsActions } from '../../store/slices/measurementsSlice/measurementsSlice';
import { fetchMeasurements } from '../../store/slices/measurementsSlice/action';

export const useMeasurements = () => {
    const dispatch = useDispatch();
    const [isClosing, setIsClosing] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [openingsDelete, setOpeningsDelete] = useState([]);
    const [additionallyDelete, setAdditionallyDelete] = useState([]);
    const [imagesDelete, setImagesDelete] = useState([]);
    const { measurementsLoading, measurementsNeedFetch } = useSelector(
        (state) => state.measurementsReducer
    );
    const [currentIndex, setCurrentIndex] = useState(null);
    const [currentUrl, setCurrentUrl] = useState(null);
    const [errorsInput, setErrorsInput] = useState({
        name: null,
        additionallyName: {},
    });

    const [popupProps, setPopupProps] = useState({
        needCrossIcon: false,
        isOpen: false,
        text: '',
        danger: '',
        cancel: '',
        success: '',
        onSubmit: () => {},
        onCancel: () => {},
    });

    const showPopup = (props) => setPopupProps({ ...popupProps, ...props, isOpen: true });
    const hidePopup = () => {
        setPopupProps({
            isOpen: false,
            text: '',
            danger: '',
            cancel: '',
            success: '',
            onSubmit: () => {},
            onCancel: () => {},
        });
    };

    useEffect(() => {
        if (measurementsNeedFetch) {
            dispatch(fetchMeasurements());
            dispatch(measurementsActions.changeNeedMeasurements(false));
        }
    }, [dispatch, measurementsNeedFetch]);

    const onAddMeasurementsList = useCallback(() => {
        dispatch(measurementsActions.changeIsShowModal(true));
    }, [dispatch]);

    const onHideModal = useCallback(
        (isEdited) => {
            if (isEdited) {
                showPopup({
                    needCrossIcon: false,
                    text: (
                        <>
                            {i18next.t('useMeasurements.return.onHideModal.text.part1')}
                            <br />
                            {i18next.t('useMeasurements.return.onHideModal.text.part2')}
                        </>
                    ),
                    danger: i18next.t('useMeasurements.return.onHideModal.danger'),
                    cancel: i18next.t('useMeasurements.return.onHideModal.cancel'),
                    onSubmit: () => {
                        hidePopup();
                        setIsClosing(true);
                        setTimeout(() => {
                            dispatch(measurementsActions.changeIsShowModal(false));
                            setIsClosing(false);
                        }, 500);
                    },
                    onCancel: () => hidePopup(),
                });
            } else {
                setIsClosing(true);
                setTimeout(() => {
                    dispatch(measurementsActions.changeIsShowModal(false));
                    setIsClosing(false);
                }, 500);
            }
        },
        [showPopup, popupProps, hidePopup]
    );

    const measurementsContextValue = {
        imageList,
        setImageList,
        currentIndex,
        setCurrentIndex,
        currentUrl,
        setCurrentUrl,
        openingsDelete,
        setOpeningsDelete,
        additionallyDelete,
        setAdditionallyDelete,
        imagesDelete,
        setImagesDelete,
        errorsInput,
        setErrorsInput,
        popupProps,
        showPopup,
        hidePopup,
        onHideModal,
    };

    return {
        measurementsLoading,
        onAddMeasurementsList,
        onHideModal,
        isClosing,
        measurementsContextValue,
        popupProps,
        hidePopup,
    };
};
